import React from 'react';
import { Button, Col } from 'react-bootstrap';

const SingleBlog = ({blog}) => {
    const {title, image, discription,readMore}=blog;
    return (
        <Col md={4} className="mb-4">
        <div className="single-blog ">
            <img className="blog-image" src={image} alt="" />
            <h4 className="blog-title ml-3 mt-2">{title}</h4>
            <p className="blog-detail">{discription}</p>
            <Button href={readMore} target="_blank" size="sm" className="buttonstyle ml-3">Read More</Button>
        </div>
    </Col>
    );
};

export default SingleBlog;